import axiosInterseptor from '../../utils/axiosInterseptor';

export default class Validate {
  static async checkEmail(email: string, signal: AbortSignal) {
    try {
      const response = await axiosInterseptor.get(`validator/check?type=email&data=${email}`, {
        signal,
      });
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
    }
  }

  static async checkEmail2(email: string) {
    try {
      const response = await axiosInterseptor.get(`validator/check?type=email&data=${email}`);
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error.response.data.error.details;
      throw dataError;
    }
  }

  static async helperEmail(email: string) {
    try {
      const response = await axiosInterseptor.get(`validator/helper?type=email&data=${email}`);
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
    }
  }

  static async normalizeEmail(email: string) {
    try {
      const response = await axiosInterseptor.get(`validator/helper?type=email&data=${email}`);
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
    }
  }

  static async checkPhone(phone: string, signal: AbortSignal) {
    try {
      const response = await axiosInterseptor.get(`validator/check?type=phone&data=${phone}`, {
        signal,
      });
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
    }
  }

  static async checkBonusCard(card: string, signal: AbortSignal) {
    try {
      const response = await axiosInterseptor.get(`validator/check?type=card&data=${card}`, {
        signal,
      });
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
    }
  }

  static async checkName(fio: string) {
    try {
      const response = await axiosInterseptor.get(`validator/check?type=name&data=${fio}`);
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
    }
  }

  static async helperName(name: string) {
    try {
      const response = await axiosInterseptor.get(`validator/helper?type=names&data=${name}`);
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
    }
  }

  static async helperSurname(surname: string) {
    try {
      const response = await axiosInterseptor.get(`validator/helper?type=surnames&data=${surname}`);
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
    }
  }

  static async helperName2({ name, type }: { name: string; type: string }) {
    try {
      const response = await axiosInterseptor.get(`validator/helper?type=${type}&data=${name}`);
      const data = await response.data;
      return data.help;
    } catch (error: any) {
      // const dataError = error;
      // throw dataError;
      return error;
    }
  }

  static async checkPassport(number: string, signal: AbortSignal) {
    try {
      const response = await axiosInterseptor.get(`validator/check?type=passport&data=${number}`, {
        signal,
      });
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
      return dataError;
    }
  }

  static async helperPassport(value: string, signal: AbortSignal) {
    try {
      const response = await axiosInterseptor.get(`validator/helper?type=passport&data=${value}`, {
        signal,
      });
      const data = await response.data;
      return data;
    } catch (error: any) {
      const dataError = error;
      throw dataError;
      return dataError;
    }
  }
}
